import {RECEIVE_ACTIVITIES} from '../action-types/activities';
import {TOP_ACTIVITIES} from '../components/constants';

export const fetchActivities = () => (dispatch) => {
  dispatch({
    type: RECEIVE_ACTIVITIES,
    activities: TOP_ACTIVITIES,
  });
};
